import { ISection } from '../../interfaces/scheduler_interfaces';
import { ScheduledSectionServant } from '../../views/course_scheduler/servants/scheduled_section_servant';
import { IRegisterSectionsDatasource } from '../../views/course_scheduler/datasources/register_sections_datasource';
import * as _4 from 'lodash4';
import { CrossCourseLinkedSectionServant } from '../../views/course_scheduler/servants/cross_course_linked_section_servant';
import { ScheduledSectionsQuery } from '../../views/course_scheduler/queries/scheduled_sections_query';
import { ISectionsDatasource } from '../../views/sections/datasources/sections_datasource';
import { ScheduledSectionStatus } from '../../views/course_scheduler/types/scheduled_section_status_enum';
import { SectionInfoServant } from '../../views/sections/servants/section_info_servant';
import { SchedulerModel } from '../../views/course_scheduler/models/scheduler_model';
import { TermCourseServant } from '../../views/term_courses/servants/term_course_servant';
import { MultiSectionServant } from '../../views/course_scheduler/servants/multi_section_servant';
import { ScheduledSectionTileServant } from '../../views/course_scheduler/servants/scheduled_section_tile_servant';
import { ScheduledSectionStatusServant } from '../../views/course_scheduler/servants/scheduled_section_status_servant';
import { AllSectionsQuery } from '../../views/course_scheduler/queries/all_sections_query';

class CorequisiteDropListController {
  private hasCoreqsToDropOrWithdraw: boolean = false;
  private sectionLabel: string = '';
  private showDropList: boolean = false;
  private showWithdrawList: boolean = false;
  private registeredInProgressLinkedSections: ISection[];
  private sectionsToDrop: ISection[];
  private sectionsToWithdraw: ISection[];
  private inProgressEnforcedCoreqs: ISection[];
  private sectionId: number;
  private section?: ISection;
  private crossCourseLinkedSectionIds: number[] = [];
  private mode: string = '';
  private courseCoreqLinkedSections: number[] = [];
  private showWithdrawText: boolean = false;
  private withdrawConfirmationText: string = '';

  constructor(
    private ngScheduledSectionServant: ScheduledSectionServant,
    private ngMultiSectionServant: MultiSectionServant,
    private ngRegisterSectionsDatasource: IRegisterSectionsDatasource,
    private ngTermCourseServant: TermCourseServant,
    private ngSectionInfoServant: SectionInfoServant,
    private ngScheduledSectionTileServant: ScheduledSectionTileServant,
    private ngScheduledSectionStatusServant: ScheduledSectionStatusServant,
    private ngSchedulerModel: SchedulerModel,
    private appConfigModel: any,
    private ngAllSectionsQuery: AllSectionsQuery,
    private ngCrossCourseLinkedSectionServant: CrossCourseLinkedSectionServant,
    private ngScheduledSectionsQuery: ScheduledSectionsQuery,
    private ngSectionsDatasource: ISectionsDatasource
  ) {}

  initilize() {
    this.section = _4.find(this.ngSectionsDatasource.metasource().derived(), { id: this.sectionId });

    if (this.section) {
      this.sectionLabel = this.appConfigModel.model.member_configs['section_label'] || 'Section';
      this.inProgressEnforcedCoreqs = this.ngScheduledSectionStatusServant.isCoreqEnforcementEnabled()
        ? this.ngScheduledSectionServant.getInProgressCoreqsRelated(this.section, this.ngAllSectionsQuery.result)
        : [];

      this.crossCourseLinkedSectionIds = this.ngCrossCourseLinkedSectionServant.getSectionIdOfLinkedCrossCourses(
        this.section.id,
        this.ngScheduledSectionsQuery.result.list
      );
      this.crossCourseLinkedSectionIds = _4.uniq(
        _4.concat(this.crossCourseLinkedSectionIds, this.courseCoreqLinkedSections)
      );

      this.registeredInProgressLinkedSections = _4.filter(
        this.ngCrossCourseLinkedSectionServant.getSectionsByIds(
          this.crossCourseLinkedSectionIds,
          this.ngSectionsDatasource.metasource().derived()
        ),
        (section: ISection) =>
          section.status === ScheduledSectionStatus.REGISTERED || section.status === ScheduledSectionStatus.IN_PROGRESS
      );

      let sectionsToDropOrWithdraw: ISection[] = [];

      if (this.mode !== 'multiSection') {
        sectionsToDropOrWithdraw = _4.concat(this.inProgressEnforcedCoreqs, this.registeredInProgressLinkedSections);
      }

      if (this.mode === 'multiSection') {
        const isMultiSectionCourse = TermCourseServant.isMultiSectionCourse(this.section._course);
        if (isMultiSectionCourse) {
          const siblings = this.ngMultiSectionServant.getScheduledSiblingSections(this.section);
          const allSectionsWithMeta = this.ngSectionsDatasource.metasource().derived();
          sectionsToDropOrWithdraw = _4.concat(
            sectionsToDropOrWithdraw,
            _4.intersectionBy(allSectionsWithMeta, siblings, 'id')
          );
        }
      }

      this.sectionsToDrop = _4.filter(sectionsToDropOrWithdraw, (section: ISection) => section.is_droppable);
      this.sectionsToWithdraw = _4.filter(sectionsToDropOrWithdraw, (section: ISection) => section.can_withdraw);

      this.showDropList = this.sectionsToDrop.length > 0;
      this.showWithdrawList =
        this.sectionsToWithdraw.length > 0 && this.ngScheduledSectionTileServant.isWithdrawEnabled();
      this.withdrawConfirmationText = _4.get(this.ngSchedulerModel.read(), 'customtext.WITHDRAW_CONFIRMATION.text', '');
    }
  }

  getRegisteredInProgressLinkedSections() {
    return this.registeredInProgressLinkedSections;
  }

  getSectionLabel(section: ISection) {
    return this.ngSectionInfoServant.getSectionLabel(section);
  }

  $onInit() {
    this.initilize();
  }
  $onChanges() {
    this.initilize();
  }
}

angular.module('capability-ng-scheduler').component('corequisiteDropList', {
  templateUrl: 'capability-ng-scheduler/src/components/corequisite_drop_list/corequisite_drop_list.html',
  bindings: {
    sectionId: '<',
    showWithdrawText: '<',
    mode: '@'
  },
  controller: CorequisiteDropListController
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/components/corequisite_drop_list/corequisite_drop_list.ts